import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=52a0c8e3&"
import script from "./DiscountForm.vue?vue&type=script&lang=js&"
export * from "./DiscountForm.vue?vue&type=script&lang=js&"
import style0 from "./DiscountForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports